<script setup>
import { useModalStore } from '../../../store/modal'
import ActionModalBase from "../ActionModalBase.vue";

const modalStore = useModalStore()
</script>

<template>
    <action-modal-base class="user-action-modal">
       <button @click.prevent="modalStore.open('EditUser', {id: modalStore.props.id}, 'body', 'bottom-right')">Edit</button>
        <button @click.prevent="modalStore.open('DeleteUser', {id: modalStore.props.id}, 'body', 'bottom-right')">Delete</button>
    </action-modal-base>
</template>

<style scoped lang="scss">
.user-action-modal {
    right: .4rem;
}
</style>
